var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamtasiaStudioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "url(#pattern0_93_592)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_93_592",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_93_592",
    transform: "translate(-0.147985 -0.148801) scale(0.00899984)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_93_592",
    width: 144,
    height: 144,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQCAYAAADnRuK4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAD5UlEQVR4nO2dz4pUVxCH61nEP0+hgn/n/PrJ+txO1k4MLhJc+gBxodPnjCIuDUQXgg64EIIT4gQRRSq04CaRceyhu+r2fB/UA9y63/1VndOLNgMAAAAAAAAAAAAAAAAAAAAAAAAASE3d3bpWu24OTc9q1z9Dl1NaeQ8Wva6tPB26fpr1ctXGxnT3+rmhlYYsSvHB1F7ms1bO2hiYtq2LtZe/optG6T89KPvDXBcse/IgjxLLW/anO5MzlpXayv34JlHDN8aZZWSxrPHyNAqBZ23rsmWjtvJzdGMoHakHtZdty8biqM4L1CgkXhzxLRu16yC6MZSOmEA6sGzw8jQqgS0b0Q2hhEBIIBIICTSKHlg2ohtCCYGQQCRQBgke7N32TeDDp/e+u/crIwx5lufdx7cIRPIsz+NXdxCIsbUcT17/5rM+QSB2nlzycIzfwIV5nfIgEPI4AnFUD0keEoix5QjEJWFY8pzoBGJhFgIhT2zynMgEInmEQMiTI3lOVAKRPEKg4wj0/M2jpSvy6x5GUJaNVTwkAgmBEEjhaUMCMcIcgRhhHp067EAs0Y5ALNEenT6cwjjGOwJxjHcSiHsgjx5FjLBDmsBFohDoOF8JAgmBEEjh44pTGDfRjkCMMM9Ulo1VPCQ7kBAIgRSeNiQQO5AjECPMo1OHHYhf4x2BWKI9On04hfFrvCMQx3gngbgH8uhRxAg7pAlcJAqBjvOVIJAQCIEUPq44hXET7QjECPNMZdlYxUOyAwmBEEjhaUMCsQM5AjHCPDp12IH4Nd4RiCXao9OHUxi/xjsCcYx3Eoh7II8eRYywQ5rARaIQ6DhfCQIJgRBI4eOKUxg30Y5AjDDPVJaNVTwkO5AQCIEUnjYkEDuQIxAjzKNThx2IX+Mdgb7jK5m/uOWbxpME/1a4KMvGqh4UiYRASJQviSwbq35gkkgIhER5ksiysa4HJ4mEQEgUn0SWjXVH8CYm0e+v765NIjvpAiGREAiJ4pLIshGRQCSREAiJYpLIshGZQF/qwd5t3zQev7qDQEi0PO8+vkUgkmg5Pnx67/3lLwgUPdoosQMhgViikUBpemDZiG4IJQRCApFASKBR9MCyUbsOoptC6Ug9qE1/WzaGpme8QI1E4vKHZaN23YxvDDUcpQet3LBs1D65wgvUOCSel0uWkaGVe+HNofwbPdixrPzYJ6dqL3/yEpVS5Nr05oeH105bZoa5Lgy97Ec3i9L/5JnuTs7bGJjuTM7UVu7zEpVD5FbupU+erzFrW5drL9uLYyP3RFrfqPp8J7foedlOuzADAAAAAAAAAAAAAAAAAAAAAAAAANgX/gXRINWtAO4ezQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamtasiaStudioLogo);
export default __webpack_public_path__ + "static/media/camtasia_studio_logo.62df5c57ff7879a5d7ec24ab73262de8.svg";
export { ForwardRef as ReactComponent };